// Variant A overrides — "The Gap" angle
// Only fields that differ from the base content in mock.js.
// Merged on top of base content by useContent when variant=a is active.

export const variantA = {
  en: {
    hero: {
      badge: "AI Coaching · Understand. Build. Deploy.",
      headingPre: "While you read this, AI is working for ",
      headingAccent: "someone else",
      headingPost: ".",
      subtitle: "Together, we build what you'll use every day.",
      cta: "Claim my free 30-min session",
      secondaryCta: "See if you qualify",
      availability: "5 clients at a time",
      availabilityCta: "Now reviewing applications",
    },
    reality: {
      narrativePre: "Everyone has access to the same tools.",
      narrativeQuote: "Not everyone knows how to make them work.",
      narrativePost: "Access isn't the advantage anymore. Implementation is.",
      punchline: "You follow every launch. Every thread. Every demo.",
      punchlineAccent: "Nothing changed.",
    },
    problem: {
      headingPre: "You're using AI. Your competitors are ",
      headingAccent: "deploying",
      headingPost: " it.",
      subtitle:
        "There's a difference between chatting with ChatGPT and having AI systems that handle your work. Most people never cross that line.",
    },
    cta: {
      headingPre: "Ready to close the ",
      headingAccent: "gap",
      headingPost: "?",
      subtitle:
        "30 minutes. We look at your work, spot where AI can take over, and map out exactly what you'll build. And walk away with running. No pitch. Just a clear plan.",
      primaryCta: "Get my free session",
    },
  },

  fr: {
    hero: {
      badge: "Coaching IA · Comprendre. Construire. Déployer.",
      headingPre: "Pendant que vous lisez ça, l'IA travaille pour ",
      headingAccent: "quelqu'un d'autre",
      headingPost: ".",
      subtitle: "On construit ensemble ce que vous utiliserez tous les jours.",
      cta: "Réserver ma session découverte",
      secondaryCta: "Voir si c'est fait pour vous",
      availability: "5 clients en simultané",
      availabilityCta: "Candidatures ouvertes",
    },
    reality: {
      narrativePre: "Tout le monde a accès aux mêmes outils.",
      narrativeQuote: "Tout le monde ne sait pas les faire travailler.",
      narrativePost: "L'accès n'est plus l'avantage. L'implémentation, si.",
      punchline: "Vous suivez chaque lancement. Chaque thread. Chaque démo.",
      punchlineAccent: "Rien n'a changé.",
    },
    problem: {
      headingPre: "Vous utilisez l'IA. Vos concurrents, eux, la ",
      headingAccent: "déploient",
      headingPost: ".",
      subtitle:
        "Il y a une différence entre discuter avec ChatGPT et avoir des systèmes IA qui gèrent votre travail. La plupart des professionnels ne franchissent jamais cette ligne.",
    },
    cta: {
      headingPre: "Prêt à combler ",
      headingAccent: "l'écart",
      headingPost: " ?",
      subtitle:
        "30 minutes. On regarde ce que vous faites, on identifie où l'IA peut prendre le relais, et on vous montre exactement ce que vous construirez. Ce que vous repartirez avec en production. Pas de pitch. Juste un plan clair.",
      primaryCta: "Obtenir ma session gratuite",
    },
  },
};
